import application from 'application/application';
import controller from './copy-clipboard.controller';

import template from './copy-clipboard.template.html';

application.directive('ngCopyClipboard', [
	function() {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				text: '<',
				getText: '&?',
				label: '@?',
				onCopied: '&?',
				color: '@?',
				positionTooltip: '@?',
				tooltipLarge: '@?',
				hoverColor: '@?',
				size: '@?',
				pb: '@?'
			},
			controller: controller,
			templateUrl: template
		};
	}
]);
